import { useContext } from 'react';
import HeaderSnackbarContext from '../contexts/headerSnackbar';

const useHeaderSnackbar = () => useContext(HeaderSnackbarContext);

export default useHeaderSnackbar;
